import clsx from "clsx";
import styles from "./StatusTag.module.scss";
import CheckFilledIcon from "@medoma/components/icons/CheckFilledIcon";
import ArrowRightFilledIcon from "@medoma/components/icons/ArrowRightFilledIcon";
import type { IStatus } from "./statusTagUtils";
import { statusDictionary } from "./statusTagUtils";
import { Tag, type ITag } from "@medoma/components/Tag/Tag";
import { useLingui } from "@lingui/react/macro";
import { visitStatusSchema } from "@medoma/models/activities";
import { humanFormat } from "@medoma/models/date-and-time";

export type IStatusTag = {
  status: IStatus;
  timestamp?: Date;
} & Partial<Pick<ITag, "variant" | "size">>;

const statusToColorMap: Record<
  IStatus,
  "lightGray" | "gray" | "blue" | "orange" | "green" | "red"
> = {
  notReady: "lightGray",
  ready: "blue",
  planned: "blue",
  travellingTo: "blue",
  ongoing: "orange",
  finished: "green",
  expired: "red",
  cancelled: "gray",
};

const Icon = ({ status }: { status: IStatus }) => (
  <div className={styles.iconWrapper}>
    <div className={clsx(styles.icon, styles[`icon-${status}`])}>
      {status === visitStatusSchema.enum.travellingTo ? (
        <ArrowRightFilledIcon />
      ) : null}
      {status === "finished" ? <CheckFilledIcon /> : null}
    </div>
  </div>
);

export const StatusTag = ({
  status,
  variant = "icon",
  size = "small",
  timestamp,
}: IStatusTag) => {
  const { t } = useLingui();
  const label = t(statusDictionary[status]);

  return (
    <Tag
      icon={<Icon status={status} />}
      color={statusToColorMap[status]}
      localizedTimestamp={
        timestamp ? humanFormat(timestamp, { timeStyle: "short" }) : undefined
      }
      label={label}
      size={size}
      variant={variant}
    />
  );
};
